@let subsection = this.subSectionService.subsection();
@if (subsection) {
  <div
    [id]="subSectionId()"
    class="relative flex h-full flex-col"
    cdkDrag
    [cdkDragData]="subSectionId()"
    [cdkDragPreviewContainer]="ref()"
  >
    <div
      [pTooltip]="subsection.customization.description"
      class="relative flex flex-row items-center justify-between gap-2 px-5 pt-3"
    >
      <div
        class="flex flex-col gap-1"
        [ngClass]="
          subSectionService.subsectionErrors().missingIds.length > 0
            ? 'text-red-600'
            : ''
        "
      >
        @if (!inlineTitleEditor()) {
          <div class="text-lg font-bold" (click)="inlineTitleEditor.set(true)">
            {{ subsection.customization.title }}
          </div>
        } @else {
          <div
            class="rounded-md border-[1px] border-slate-300 px-2 text-lg font-bold"
          >
            <input
              #titleInput
              type="text"
              placeholder="titolo"
              [formControl]="title"
              (blur)="closeInlineTitleEditor()"
            />
          </div>
        }
        @if (!inlineSubTitleEditor()) {
          <div (click)="inlineSubTitleEditor.set(true)">
            {{ subsection.customization.subTitle }}
          </div>
        } @else {
          <div class="rounded-md border-[1px] border-slate-300 px-2">
            <input
              #subTitleInput
              type="text"
              placeholder="sottotitolo"
              [formControl]="subTitle"
              (blur)="closeInlineSubTitleEditor()"
            />
          </div>
        }
      </div>
      <div class="flex flex-row items-center gap-1">
        @if (subSectionService.subsectionErrors().missingIds.length > 0) {
          <mat-icon
            class="icon-size-5 text-amber-700"
            svgIcon="heroicons_outline:exclamation-triangle"
          ></mat-icon>
        }
        @if (!inlinePointsEditor()) {
          <div
            class="w-16 text-end text-lg font-bold"
            (click)="inlinePointsEditor.set(true)"
          >
            {{ subsection.customization.points }} pt
          </div>
        } @else {
          <div
            class="self-end rounded-md border-[1px] border-slate-300 px-2 text-lg font-bold"
          >
            <input
              #pointsInput
              class="w-10"
              type="number"
              [formControl]="points"
              (blur)="closeInlinePointsEditor()"
            />
          </div>
        }
      </div>
    </div>
    <div
      [cdkMenuTriggerFor]="menu"
      [cdkMenuPosition]="positions"
      cdkDragHandle
      [id]="'cdkMenu_' + subSectionId()"
      class="absolute right-0 -mr-8 flex h-full flex-col overflow-hidden rounded-md py-4"
    >
      <div
        class="flex h-full flex-row rounded-md bg-slate-200 hover:bg-slate-300"
      >
        <mat-icon color="black" class="my-auto flex">drag_indicator</mat-icon>
      </div>

      <div
        *cdkDragPreview
        class="flex cursor-pointer flex-row rounded-2xl bg-white py-3 pl-2 pr-3 shadow-md"
      >
        <div class="w-max justify-center self-center px-2">
          {{ subSectionId() }}
        </div>
      </div>

      <div *cdkDragPlaceholder class="placeholder flex-1 p-3">
        <div
          class="min-h-10 w-full rounded-md bg-gray-500 bg-opacity-15 outline-dotted outline-4 outline-offset-2 outline-gray-300"
        ></div>
      </div>
    </div>
    <div
      cdkDropList
      [id]="subSectionId()"
      [cdkDropListData]="subsection.children"
      (cdkDropListDropped)="drop($event)"
      [cdkDropListConnectedTo]="dragdropService.subSectionList()"
      class="flex w-full flex-auto flex-col gap-2 p-10 px-5 py-3"
    >
      @for (widget of subsection.children; track widget) {
        <lib-base-widget-edit [widgetId]="widget"></lib-base-widget-edit>
      }
    </div>
  </div>
  <ng-template #menu>
    <div class="ml-5 flex flex-col rounded-md" cdkMenu>
      <button
        mat-icon-button
        cdkMenuItem
        pTooltip="Personalizza Sottosezione"
        tooltipPosition="right"
        (click)="subSectionService.subsectionCustomizationVisible.set(true)"
      >
        <mat-icon svgIcon="heroicons_outline:cog-8-tooth"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="removeSubSection()"
        cdkMenuItem
        pTooltip="Rimuovi Sottosezione"
        tooltipPosition="right"
      >
        <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
      </button>
      <button
        cdkMenuItem
        pTooltip="Copia Sottosezione"
        tooltipPosition="right"
        mat-icon-button
        (click)="subSectionService.copySubSection()"
      >
        <mat-icon svgIcon="heroicons_outline:clipboard"></mat-icon>
      </button>
      @if (subSectionService.subsectionPasteEnabled()) {
        <button
          (click)="subSectionService.pasteSubSection()"
          cdkMenuItem
          pTooltip="Incolla Sottosezione"
          mat-icon-button
        >
          <mat-icon svgIcon="heroicons_outline:clipboard-document"></mat-icon>
        </button>
      }
      @if (subSectionService.widgetPasteEnabled()) {
        <button
          (click)="subSectionService.pasteWidget()"
          cdkMenuItem
          pTooltip="Incolla Widget"
          mat-icon-button
        >
          <mat-icon svgIcon="heroicons_outline:clipboard-document"></mat-icon>
        </button>
      }
    </div>
  </ng-template>

  @if (subSectionService.subsectionCustomizationVisible()) {
    <lib-subsection-customization-panel />
  }
}
